// code128 - S47.3b.
// Encoder Code 128B (subset B = ASCII imprimible 32..127). Sin libs.
//
// Algoritmo:
//   1. Filtrar input a ASCII 32..127.
//   2. Anteponer START B (valor 104).
//   3. Mapear cada char a valor = charCode - 32.
//   4. Calcular checksum = (104 + Sum_{i=1..n}(i * valor_i)) mod 103.
//   5. Anexar checksum + STOP (valor 106).
//   6. Convertir cada valor a su patron de 6 elementos (alternando bar/space,
//      empezando con bar). STOP usa 7 elementos.
//
// Output: { bars: Array<0|1>, value: string filtrado }.
//   bars: 1 = barra negra (1 modulo), 0 = espacio blanco (1 modulo).

// Tabla estandar Code 128 (107 patrones). Cada string son 6 anchos de
// elementos (excepto el ultimo, STOP = 7). Total = 11 modulos por simbolo
// (13 para STOP).
const P = [
  '212222','222122','222221','121223','121322',
  '131222','122213','122312','132212','221213',
  '221312','231212','112232','122132','122231',
  '113222','123122','123221','223211','221132',
  '221231','213212','223112','312131','311222',
  '321122','321221','312212','322112','322211',
  '212123','212321','232121','111323','131123',
  '131321','112313','132113','132311','211313',
  '231113','231311','112133','112331','132131',
  '113123','113321','133121','313121','211331',
  '231131','213113','213311','213131','311123',
  '311321','331121','312113','312311','332111',
  '314111','221411','431111','111224','111422',
  '121124','121421','141122','141221','112214',
  '112412','122114','122411','142112','142211',
  '241211','221114','413111','241112','134111',
  '111242','121142','121241','114212','124112',
  '124211','411212','421112','421211','212141',
  '214121','412121','111143','111341','131141',
  '114113','114311','411113','411311','113141',
  '114131','311141','411131','211412','211214',
  '211232','2331112',
];

const START_B = 104;
const STOP = 106;

function _patternToBars(p) {
  const out = [];
  for (let i = 0; i < p.length; i += 1) {
    const w = parseInt(p[i], 10);
    const bar = (i % 2 === 0) ? 1 : 0;
    for (let j = 0; j < w; j += 1) out.push(bar);
  }
  return out;
}

function _filterPrintable(s) {
  const v = String(s == null ? '' : s);
  let out = '';
  for (let i = 0; i < v.length; i += 1) {
    const c = v.charCodeAt(i);
    if (c >= 32 && c <= 127) out += v.charAt(i);
  }
  return out;
}

export function encodeCode128B(value) {
  const s = _filterPrintable(value);
  const codes = [START_B];
  for (let i = 0; i < s.length; i += 1) codes.push(s.charCodeAt(i) - 32);

  let csum = START_B;
  for (let i = 0; i < s.length; i += 1) {
    csum += (i + 1) * (s.charCodeAt(i) - 32);
  }
  csum = csum % 103;
  codes.push(csum);
  codes.push(STOP);

  let bars = [];
  for (let i = 0; i < codes.length; i += 1) {
    const pat = P[codes[i]];
    bars = bars.concat(_patternToBars(pat));
  }
  return { bars: bars, value: s };
}
